import { render, staticRenderFns } from "./Portfolio.vue?vue&type=template&id=6bcf8a6c&"
import script from "./Portfolio.vue?vue&type=script&lang=js&"
export * from "./Portfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports